/**
 * @generated SignedSource<<beab7c81a1cfd7a9e019c32e0155ce41>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b

import type { ConcreteRequest } from 'relay-runtime';
export type useFeedFollowFeedFollowQuery$variables = Record<PropertyKey, never>;
export type useFeedFollowFeedFollowQuery$data = {
  readonly getFeedUserConfig: {
    readonly accountIds: ReadonlyArray<string | null | undefined>;
  } | null | undefined;
};
export type useFeedFollowFeedFollowQuery = {
  response: useFeedFollowFeedFollowQuery$data;
  variables: useFeedFollowFeedFollowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "FollowingFeedGetUserConfig",
    "kind": "LinkedField",
    "name": "getFeedUserConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "accountIds"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useFeedFollowFeedFollowQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFeedFollowFeedFollowQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
    "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
    "metadata": {},
    "name": "useFeedFollowFeedFollowQuery",
    "operationKind": "query",
    "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
  }
};
})();

(node as any).hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";

export default node;
